import {
  serviceNumberSchema,
  serviceNumberUI,
  ssnSchema,
  ssnUI,
  titleUI,
  vaFileNumberSchema,
  vaFileNumberUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { veteranFields, FORM_21_4502 } from '../definitions/constants';

const { IDENTIFICATION_INFORMATION: I, PERSONAL_INFO: P } = FORM_21_4502;

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(I.TITLE, I.PAGE_DESCRIPTION),
    'ui:options': {
      preserveHiddenData: true,
      forceDivWrapper: true,
    },
    [veteranFields.parentObject]: {
      [veteranFields.ssn]: {
        ...ssnUI(),
        'ui:errorMessages': {
          pattern: P.ERROR_SSN_PATTERN,
          required: I.ERROR_SSN_REQUIRED,
        },
      },
      [veteranFields.vaFileNumber]: vaFileNumberUI(P.VA_FILE_NUMBER),
      [veteranFields.veteranServiceNumber]: serviceNumberUI(
        P.VETERAN_SERVICE_NUMBER,
      ),
    },
  },
  schema: {
    type: 'object',
    properties: {
      [veteranFields.parentObject]: {
        type: 'object',
        properties: {
          [veteranFields.ssn]: ssnSchema,
          [veteranFields.vaFileNumber]: vaFileNumberSchema,
          [veteranFields.veteranServiceNumber]: serviceNumberSchema,
        },
        required: [veteranFields.ssn],
      },
    },
  },
};
